import styled from 'styled-components';

export const InfoBlockContent = styled.div`
  color: var(--color-text);

  a {
    color: var(--color-text);
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    text-decoration: underline;

    &:hover {
      color: var(--color-link);
    }
  }

  .pencil-button {
    cursor: pointer;

    &:hover {
      color: var(--color-link);
    }
  }
`;
